import type { HTMLAttributes } from 'react';

import { cn } from '../lib/cn';

interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

const sizeMap = {
  sm: 'max-w-3xl',
  md: 'max-w-5xl',
  lg: 'max-w-7xl',
  xl: 'max-w-[1440px]',
} as const;

export function Container({ size = 'lg', className, ...props }: ContainerProps) {
  return (
    <div
      className={cn('mx-auto min-w-0 w-full px-4 md:px-6', sizeMap[size], className)}
      {...props}
    />
  );
}
